const formatOfflineTime = (timestamp) => {
  if (!timestamp) return 'Never connected';
  const diff = Date.now() - new Date(timestamp).getTime();
  if (diff < 60000) return 'Offline just now';
  if (diff < 3600000) return `Offline ${Math.floor(diff / 60000)}m ago`;
  if (diff < 86400000) return `Offline ${Math.floor(diff / 3600000)}h ago`;
  return `Offline since ${new Date(timestamp).toLocaleDateString()}`;
};

const StatusBadge = ({ connected, timestamp }) => (
  <span className={`status-badge ${connected ? 'status-badge--online' : 'status-badge--offline'}`}>
    <span className="status-badge__dot" />
    {connected ? 'Online' : formatOfflineTime(timestamp)}
  </span>
);

export default StatusBadge;